import type { ActividadEconomica } from '../lib/supabase';

export type OwnerTipo = 'lumisial' | 'diocesis' | 'provincia' | 'global';

export interface OwnerContext {
  readonly tipo: OwnerTipo;
  readonly id: string;
  readonly nombre: string;
}

/** Extrae el ownerContext de una actividad ya cargada */
export function getOwnerFromActividad(
  actividad: ActividadEconomica
): OwnerContext | null {
  if (actividad.lumisial_id) {
    return { tipo: 'lumisial', id: actividad.lumisial_id, nombre: '' };
  }
  if (actividad.diocesis_id) {
    return { tipo: 'diocesis', id: actividad.diocesis_id, nombre: '' };
  }
  if (actividad.provincia_eclesiastica_id) {
    return { tipo: 'provincia', id: actividad.provincia_eclesiastica_id, nombre: '' };
  }
  return null;
}

/** Construye el payload de owner para inserción en DB */
export function buildOwnerPayload(owner: OwnerContext) {
  return {
    lumisial_id: owner.tipo === 'lumisial' ? owner.id : null,
    diocesis_id: owner.tipo === 'diocesis' ? owner.id : null,
    provincia_eclesiastica_id: owner.tipo === 'provincia' ? owner.id : null,
  };
}
